import React, { useState, useContext, useEffect, Fragment } from "react";
import { Typography, Box, Grid, IconButton, useMediaQuery } from "@mui/material";
import SquareIcon from "@mui/icons-material/Square";
import { useTheme } from "@mui/material/styles";
import { defaultTheme } from "../index";
import { DataContext } from "../context/DataContext";
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import CloseIcon from "@mui/icons-material/Close";
import ListIcon from "@mui/icons-material/List";

export default function Legend(props) {

    const isMobil = !useMediaQuery("(min-width:900px)");
    const dataContext = useContext(DataContext);
    const theme = useTheme(defaultTheme);
    const [layers, setLayers] = useState([
        { name: "FLIK Fläche", active: true, icon: "square" },
        { name: "Schutzgebiete", color: "protectedAreas", active: true, icon: "square" },
        { name: "Organische Böden", color: "GLöZ2Areas", active: true, icon: "square" },
        { name: "NUT2-Gebiete", color: "NUT2Line", active: true, icon: "line" },
    ]);
    const [isCollapsed, setIsCollapsed] = useState(isMobil);
    const mobileLegendTop = 270;

    const allLayersInactive = layers.every((layer) => !layer.active);

    useEffect(() => {
        setLayers((current) => {
            const newState = [...current];

            if (dataContext?.flikDataHidden !== undefined) {
                const flikDataActive = !dataContext.flikDataHidden;
                newState[0].active = flikDataActive;
            }

            if (dataContext?.protectedAreaHidden !== undefined) {
                newState[1].active = !dataContext.protectedAreaHidden;
            }

            if (dataContext?.GLöZ2AreasHidden !== undefined) {
                newState[2].active = !dataContext.GLöZ2AreasHidden;
            }
            if (dataContext?.NUT2Hidden !== undefined) {
                newState[3].active = !dataContext.NUT2Hidden;
            }
            return newState;
        });
    }, [
        dataContext?.flikDataHidden,
        dataContext?.protectedAreaHidden,
        dataContext?.GLöZ2AreasHidden,
        dataContext?.NUT2Hidden
    ]);

    useEffect(() => {
        setIsCollapsed(isMobil);
    }, [isMobil]);

    return (
        <>
            {!allLayersInactive && isMobil && isCollapsed && (
                <Box
                    sx={{
                        position: "fixed",
                        backgroundColor: "rgba(55,55,55,0.9)",
                        width: 120,          
                        zIndex: 150,
                        right: "0px",
                        top: `${mobileLegendTop}px`,
                        borderRadius: "10px 0 0 10px",
                        boxShadow: 3,
                    }}
                >
                    <IconButton
                        aria-label="legend-oeffnen"
                        onClick={() => setIsCollapsed(false)}
                        sx={{
                            display: "flex",
                            gap: 1,
                            color: "#fff",
                            px: 1.5,
                            py: 1,
                        }}
                    >
                        <ListIcon />
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            Legende
                        </Typography>
                    </IconButton>
                </Box>
            )}
            {!allLayersInactive && (!isMobil || !isCollapsed) && (
                <Box
                    sx={{
                        position: isMobil ? "fixed" : "absolute",
                        backgroundColor: "rgba(55,55,55,0.9)",
                        zIndex: 15,
                        right: isMobil ? "0px" : "80px" ,
                        bottom: isMobil ?  "auto" : "20px",
                        top: isMobil ? `${mobileLegendTop}px` : "auto",
                        width: "250px",
                        height: "auto",
                        padding: "10px 15px 10px",
                        borderRadius: isMobil ? "12px 0 0 12px" : 0,
                    }}
                >
                    {isMobil && (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 1,
                            }}
                        >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <ListIcon sx={{ color: "#fff" }} />
                                <Typography variant="h6" color="secondary">
                                    Legende
                                </Typography>
                            </Box>
                            <IconButton
                                aria-label="legend-schliessen"
                                onClick={() => setIsCollapsed(true)}
                                sx={{ color: "#fff", p: 0.5 }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    )}
                    <Grid container>
                        {layers?.map((layer) =>
                            layer.name !== "FLIK Fläche"
                                ? layer.active && (
                                      <Fragment key={layer.name}>
                                          <Grid item size={2}>
                                              {layer.icon === "square" ? <SquareIcon
                                                  sx={{
                                                      color: theme.palette
                                                          .layers[layer.color],
                                                  }}
                                              />: <HorizontalRuleIcon sx={{
                                                      color: theme.palette
                                                          .layers[layer.color],
                                                  }}></HorizontalRuleIcon>}
                                          </Grid>
                                          <Grid item size={1}></Grid>
                                          <Grid item size={8}>
                                              <Typography
                                                  varian="body2"
                                                  color="secondary"
                                              >
                                                  {layer.name}
                                              </Typography>
                                          </Grid>
                                      </Fragment>
                                  )
                                : layer.active && (
                                      <Fragment key={layer.name}>
                                          <Grid item size={0.66}>
                                              <SquareIcon
                                                  //fontSize="small"
                                                  sx={{
                                                      color: theme.palette
                                                          .layers.apt,
                                                  }}
                                              />
                                          </Grid>
                                          <Grid item size={0.66}>
                                              <SquareIcon
                                                  //fontSize="small"
                                                  sx={{
                                                      color: theme.palette
                                                          .layers.not_apt,
                                                  }}
                                              />
                                          </Grid>
                                           <Grid item size={0.6}>
                                              <SquareIcon
                                                  //fontSize="small"
                                                  sx={{
                                                      color: theme.palette
                                                          .layers.not_defined,
                                                  }}
                                              />                                               
                                          </Grid>
                                           <Grid item size={1}/>
                                          <Grid item size={9}>
                                              <Typography
                                                  varian="body2"
                                                  color="secondary"
                                              >
                                                  {layer.name}
                                              </Typography>
                                          </Grid>
                                      </Fragment>
                                  )
                        )}
                    </Grid>
                </Box>
            )}
        </>
    );
}
